import 'leaflet/dist/leaflet.css';
import './style.css';
import { render } from 'preact';
import type { AppConfig } from '../shared/schemas.ts';
import { Toast } from './components/ui.tsx';
import { api, config, route } from './lib.ts';
import { HomePage } from './pages/Home.tsx';
import { MeetupPage } from './pages/Meetup.tsx';

function App() {
  if (!config.value) return <div class="card">Loading…</div>;
  const m = route.value.match(/^\/m\/([\w-]+)/);
  return (
    <>
      <header class="topbar">
        <a href="/" class="brand">
          <img src="/icon.svg" alt="" width={28} height={28} /> Midway
        </a>
        <span class="tagline">meet in the middle</span>
      </header>
      <main>{m ? <MeetupPage key={m[1]} id={m[1]} /> : <HomePage />}</main>
      <Toast />
    </>
  );
}

// Internal links navigate without a reload.
document.addEventListener('click', (e) => {
  const a = (e.target as HTMLElement).closest('a');
  if (!a || a.target || a.hasAttribute('download') || e.metaKey || e.ctrlKey) return;
  const u = new URL(a.href, location.href);
  if (u.origin !== location.origin || !/^\/m\/|^\/$/.test(u.pathname)) return;
  e.preventDefault();
  history.pushState({}, '', u.pathname);
  route.value = u.pathname;
  window.scrollTo(0, 0);
});

// iOS Safari ignores user-scalable=no; block its page pinch gestures. The map listens to pointer
// events, which are unaffected, so map pinch-zoom keeps working.
for (const type of ['gesturestart', 'gesturechange', 'gestureend']) {
  document.addEventListener(type, (e) => e.preventDefault(), { passive: false });
}

api<AppConfig>('/api/config').then((c) => {
  config.value = c;
});
render(<App />, document.getElementById('app')!);
